<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">姓名</span>
         <el-input v-model.trim="name" placeholder="请输入" style="width: 150px;"/>
      </div>
      
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">交易时间开始</span>
	    <el-date-picker
	        v-model="createTime"
	        style="width: 180px;"
	        type="datetime"
	  			class="reset-clear"
	  			:clearable="false"
	  			 unlink-panels
	        value-format="yyyy-MM-dd HH:mm:ss"
	        start-placeholder="开始时间"
	        />
	  </div> 
	  
	  
	  	<div class="dlblock-mb20 mr10">
	    <span class="pr5">交易时间结束</span>
	    <el-date-picker
	      v-model="updateTime"
	  		  style="width: 180px;"
	      type="datetime"
	      :clearable="false"
	      unlink-panels
	      end-placeholder="结束时间"
	      value-format="yyyy-MM-dd HH:mm:ss"
	       />
	  </div> 
	  
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">交易状态</span>
	    <el-select v-model="tradeSts" class="w150" clearable>
	        <el-option label="未交易" value="0"/>
	  		<el-option label="交易成功" value="1"/>	  
	        <el-option label="失败" value="2"/>
	    </el-select>
	  </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">交易备注</span>
	    <el-select v-model="tradeMsg" class="w150" clearable>
	      <el-option label="当前时段超限" value="当前时段超限"/>
		  <el-option label="流水号已存在" value="流水号已存在"/>	  
	      <el-option label="用户已冻结!" value="用户已冻结!"/>
		  <el-option label="系统前端处理失败" value="系统前端处理失败"/>
		  <el-option label="系统处理失败" value="系统处理失败"/>
	    </el-select>
	  </div>
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getNhTransactionAndFaceRecordListFn()">
          搜索
        </el-button>
		
		<el-button type="primary" @click="getNhMonthlyStatisticsFn()">
		  月份统计
		</el-button>
		
      </div>
	  
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">     	  
	  <el-table-column align="center" prop="tradeId"         label="交易订单号">      </el-table-column>
	  <el-table-column align="center" prop="tradeDate"         label="交易日期">      </el-table-column>
	  <el-table-column align="center" prop="devId"         label="交易消费机号">      </el-table-column>
	  <el-table-column align="center" prop="userName"         label="姓名">      </el-table-column>
	  <el-table-column align="center" prop="userId"         label="交易用户">      </el-table-column>
	  <el-table-column align="center" prop="consTime"         label="餐次时间">      </el-table-column>
	  <el-table-column align="center" prop="tradeAmt"         label="交易金额(元)">      </el-table-column>
	  <el-table-column align="center" prop="tradeTime"         label="交易时间">      </el-table-column>
	  <el-table-column align="center" prop="tradeSts"         label="交易状态">      </el-table-column>
	  <el-table-column align="center" prop="tradeMsg"         label="交易备注">      </el-table-column>
	  <el-table-column align="center" prop="libraryPicPath"         label="人脸库">      </el-table-column>
	  <el-table-column align="center" prop="catchPicPath"         label="人脸抓拍">      </el-table-column>
	  
	  <el-table-column align="center" width="200" label="操作">
	    <template slot-scope="{row}">
	      <a class="glob-a" @click="statusBtn(3, row)">查看</a>
	    </template>
	  </el-table-column>
	  
	</el-table>  
	  
	<!-- 详情 -->
	<el-dialog title="查看" :visible.sync="detailModal" fullscreen>
	  <detail :id="detailId"/>
	</el-dialog>
	  
    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>
	
	
	<!-- 月份统计 -->
	<el-dialog title="月份统计" :visible.sync="dialogMonthlyStatistics.modal" width="1400px">
	    <el-form label-width="150px">
		
		 <el-table class="my-table" :data="subTableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
		   <el-table-column align="center" prop="dayTime"  label="时间">  </el-table-column>
		   <el-table-column align="center" prop="num"      label="数量FT">  </el-table-column>
	
		   <el-table-column align="center" prop="successNumberOfTransactions"      label="交易成功">  </el-table-column>
		   <el-table-column align="center" prop="currentPeriodVverrun"      label="当前时段超限">  </el-table-column>
		   <el-table-column align="center" prop="serialNumberAlreadyExists"      label="流水号已存在">  </el-table-column>
		   <el-table-column align="center" prop="userIsFrozen"      label="用户已冻结">  </el-table-column>
		   <el-table-column align="center" prop="systemFrontEndProcessingFailed"      label="系统前端处理失败">  </el-table-column>
		   <el-table-column align="center" prop="systemProcessingFailed"      label="系统处理失败">  </el-table-column>
		   <el-table-column align="center" prop="other"      label="其他">  </el-table-column>
		   <el-table-column align="center" prop="reconciliation"      label="对数(0正常)">  </el-table-column>
		   
		   
		   <el-table-column align="center" prop="faceRecognitionRecordSize"  label="每天刷脸记录明细数量FR">  </el-table-column>
		   <el-table-column align="center" prop="ftAndFr"  label="FT与FR">  </el-table-column>
		   <el-table-column align="center" prop="matchingIdsTimeNum"  label="相互匹配的UseridTime数量">  </el-table-column>
		   <el-table-column align="center" prop="faceRnRrdSizeMatcTimeNum"  label="每天刷脸记录明细-相互匹配的UseridTime数量">  </el-table-column>
		   <el-table-column align="center" prop="narnFrrNum"  label="本条刷脸与交易流水记录不存在与刷脸记录当中">  </el-table-column>
		   
		 </el-table> 
		 
	    </el-form>
	</el-dialog>
	
  </div>
</template>

<script>
  import Detail from './Detail.vue'
	
  import {
    getNhTransactionAndFaceRecordList,
	//月份统计
	getNhTransactionAndFaceMonthlyStatisticsList
  } from '@/api'

  export default {
	name: 'orderList',
	components: {Detail},
    data () {
      return {
        date: [],
        status: '',
        name: '',
        tableData: [],
		//月份统计
		subTableData:[],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        // 详情
        detailId: '',
        detailModal: false,
		//创建时间
		createTime:'',
		//更新时间
		updateTime:'',
		//交易状态
		tradeSts:'',
		//交易备注
		tradeMsg:'',
		//月份统计
		dialogMonthlyStatistics:{
			 modal: false
		}
      }
    },
    created () {
        this.getNhTransactionAndFaceRecordListFn()
    },
    methods: {
	  //月份统计
	  getNhMonthlyStatisticsFn(){
		this.dialogMonthlyStatistics = {
		 modal: true }	
		 this.getNhTransactionAndFaceMonthlyStatisticsListFn()
	  },
	  // t: 1切换状态 2广告权限 3查看
	  statusBtn (t, row) {
		  if( t ==3 ) {
		    this.detailModal = true
		    this.detailId = row.orderId
		  }
	  },
	  //月份统计
	  getNhTransactionAndFaceMonthlyStatisticsListFn(){
		  this.tableLoading = true
		  getNhTransactionAndFaceMonthlyStatisticsList().then(res => {
		    this.subTableData = res.data
		  }).finally(() => {
		    this.tableLoading = false
		  })
	  },
      getNhTransactionAndFaceRecordListFn () {
        this.tableLoading = true
        getNhTransactionAndFaceRecordList({
          pageNum: this.pages.page,
          name: this.name,
          createTime: this.createTime,
          updateTime: this.updateTime,
		  //交易状态
		  tradeSts:this.tradeSts,
		  //交易备注
		  tradeMsg:this.tradeMsg
        }).then(res => {
		  console.info(res,"查询客如云订单");
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getNhTransactionAndFaceRecordListFn()
      },
    }
  }
</script>

<style scoped>

</style>
